import styled from 'styled-components';

export const DivInput = styled.div`

`;

export const DivButton = styled.div`
    @media (max-width: 700px){
      margin-left:auto;
      margin-right:auto;
      margin-bottom:50px;
    }
    .buttonBack {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #6C5AF4;
        border-radius: 8px;
        color: #6C5AF4;
        @media (max-width: 700px){
          width: 130px;
          height: 49px;
        }
      }

      .buttonBack:hover {background: #FFFFFF}

      .buttonSend {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #6C5AF4;
        border-radius: 8px;
        color: #FFFFFF;
        float:right;

        @media (max-width: 700px){
          width: 130px;
          height: 49px;
        }
      }

      .buttonSend:hover {background: #6C5AF4;}

 `;
